export default __webpack_public_path__ + "static/media/element_61.d52d6820.webp";